goog.provide('el8.appanalytics.dialog.viewBulkLetterPatients');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appanalytics.dialog.viewBulkLetterPatients');
goog.require('el8.app.pageLayout');

/**
 * Shamelessly copy/pasted from viewCqmPatients.js in anticipation that we'll
 * rewrite this in React.
 */
el8.appanalytics.dialog.viewBulkLetterPatients = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: "",
        modal: true,
        height: function() {
            return el8.app.pageLayout.getAppHeight() - 100;
        },
        width: 650,
        contentFn: el8.template.appanalytics.dialog.viewBulkLetterPatients.container,
        showXButton: true
    });

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        var bulkLetter = spec.bulkLetter;
        var listName = spec.listName;
        super_show.call(that);
        $('.overlayContainer', that.getContainer()).html(
            '<div class="el8Loading"></div>'
        );
        $.el8_ajax({
            url: '/bulk-letter/' + bulkLetter.id + '/patient-list/' + listName + '/',
            success: function(data) {
                initTabs(bulkLetter, data);
            }
        });
    };

    function initTabs(bulkLetter, patientList) {
        $('.overlayContainer', that.getContainer()).html(
            el8.template.appanalytics.dialog.viewBulkLetterPatients.content({
                'header': patientList.full_name + ' -- ' + bulkLetter.description,
                'description': patientList.description,
                'numTabs': patientList.section_names.length
            })
        );

        if (patientList.sections.length > 1) {
            var tabbedNav = new el8.uiwidget.TabbedNav();
            tabbedNav.init({wrapper: $('.tabbed-nav', that.getContentElt())});
            for (var i = 0; i < patientList.section_names.length; i++) {
                _addTab(tabbedNav, patientList, i);
            }
            tabbedNav.showTab('patient-list-tab-0');
        }
        else {
            $('.patient-list', that.getContentElt()).html(
                el8.template.appanalytics.dialog.viewBulkLetterPatients.list({
                    patientList: patientList.sections[0]
                })
            );
        }
    }

    function _addTab(tabbedNav, patientList, i) {
        var tabSelector = '.patient-list-tab-' + i;
        var listSection = patientList.sections[i];
        tabbedNav.addTab({
            title: patientList.section_names[i],
            name: 'patient-list-tab-' + i,
            contentDiv: $(tabSelector, that.getContentElt()),
            showTabFn: function() {
                $(tabSelector, that.getContentElt()).html(
                    el8.template.appanalytics.dialog.viewBulkLetterPatients.list({
                        patientList: listSection
                    })
                );
            }
        });
    }

    return that;

})();
